import { Badge, Button, Checkbox, Flex, Text, Tooltip, Tr, useToast } from '@chakra-ui/react'
import { motion } from 'framer-motion'
import * as S from '../../../global/GlobalStyles'
import { formatDate } from '../../../utils/formatDate'
import { firstLetterUpperCaseAndRestLowerCase } from '../../../utils/capitalFirstLetter'
import { Modal } from './components/Modal'
import React, { memo } from 'react'
import { api } from '../../../services/api'
import { BiCopy } from 'react-icons/bi'
import { user } from '../../../helpers/user'
import Axios from 'axios'
import { format } from 'date-fns'
import { useMutation, useQueryClient } from 'react-query'

const codUsu = user.codigo_usuario

const isAdmin = ['14', '30'].some((str) => codUsu?.toString().includes(str))

const RowComponent = ({ item, index, handleSelectLayout, selectedId }) => {
  const [showImage, setShowImage] = React.useState(false)
  const [hasCopied, setHasCopied] = React.useState(false)
  const [isBlocked, setIsBlocked] = React.useState(true)
  console.log('item', item)

  const queryClient = useQueryClient()

  const [loading, setLoading] = React.useState(false)

  const toast = useToast()

  const codUsu = user.codigo_usuario

  async function initCounter() {
    const response = await api.get(
      `${process.env.REACT_APP_BASE_URL}/site/v2/fluxo-layout/atualiza-inicio-layout/${item.id}/${item.numero_nota}/${item.codigo_produto}/${item.sequencia}/${codUsu}`
    )

    return response.data
  }

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: initCounter,
    onSuccess: () => {
      setIsBlocked(false)

      queryClient.invalidateQueries('info-solicitacao-layout')
    },
  })

  function handleCopy(item) {
    navigator.clipboard.writeText(item)
    setHasCopied(true)
  }

  async function updatePrioridade() {
    const params = {
      id: item.id,
    }

    try {
      setLoading(true)

      const response = await Axios.post('https://api.innovationbrindes.com.br/api/site/v2/fluxo-layout/upload-pendencia-layout', params)

      queryClient.invalidateQueries('info-solicitacao-layout')

      toast({
        title: `O layout ${item.numero_innovation} foi marcado como prioridade!`,
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      })

      setLoading(false)
    } catch (err) {
      console.log(err)

      toast({
        title: `Ocorreu um erro ao marcar o layout ${item.numero_innovation} como prioridade!`,
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      })

      setLoading(false)
    }
  }

  return (
    <>
      <Tr
        _hover={{
          bgColor: item.prioridade ? 'red.100' : 'gray.300',
        }}
        bgColor={item.prioridade ? 'red.200' : index % 2 === 0 ? 'gray.50' : 'gray.100'}
      >
        <S.Td>
          <Text>{formatDate(item.data_solicitacao).slice(0, 5)}</Text>
          <Text>{formatDate(item.data_solicitacao).slice(7, 12)}</Text>
        </S.Td>
        <S.Td position="relative">
          <Badge fontSize="12px" colorScheme="red" position="absolute" top="0" left="0">
            {item.vetorizacao && 'Vetorização'}
          </Badge>
          {firstLetterUpperCaseAndRestLowerCase(item.tipo_pedido)}
        </S.Td>
        <S.Td>
          <Flex>
            <Text as={'span'}>{item.numero_innovation}</Text>
            <Tooltip label="Copiar número pedido" bg="gray.300" color="gray.800" placement="top" fontSize="md" hasArrow>
              <Text
                as={'span'}
                cursor={'pointer'}
                onClick={() => handleCopy(item.numero_innovation)}
                ml={2}
                _hover={{
                  filter: 'brightness(0.8)',
                  textDecoration: 'underline',
                }}
              >
                <BiCopy />
              </Text>
            </Tooltip>
          </Flex>
        </S.Td>
        <S.Td cursor={'pointer'} onMouseEnter={() => setShowImage(true)} onMouseLeave={() => setShowImage(false)}>
          <Flex>
            <Text
              as={'a'}
              href={item.url_Produto}
              target="_blank"
              color={item.url_Produto === '' ? 'red.500' : 'blue.500'}
              _hover={{
                filter: 'brightness(0.8)',
                textDecoration: 'underline',
              }}
              cursor={'pointer'}
            >
              {item.referencia}
            </Text>
            <Tooltip label="Copiar número referência" bg="gray.300" color="gray.800" placement="top" fontSize="md" hasArrow>
              <Text
                as={'span'}
                cursor={'pointer'}
                onClick={() => handleCopy(item.referencia)}
                ml={2}
                _hover={{
                  filter: 'brightness(0.8)',
                  textDecoration: 'underline',
                }}
              >
                <BiCopy />
              </Text>
            </Tooltip>
          </Flex>
        </S.Td>
        <S.Td>{firstLetterUpperCaseAndRestLowerCase(item.nome_vendedor)}</S.Td>
        <S.Td position={'relative'}>
          <Tooltip label={item.descricao_produto}>
            <Text maxW="90px" isTruncated>
              {firstLetterUpperCaseAndRestLowerCase(item.descricao_produto)}
            </Text>
          </Tooltip>
          {showImage && (
            <Flex
              position={'absolute'}
              top={'4rem'}
              right={'1rem'}
              borderRadius={'md'}
              border={'1px solid'}
              borderColor={'gray.200'}
              padding={2}
              zIndex={'10'}
              _after={{
                content: '""',
                position: 'absolute',
                top: '-1rem',
                left: '50%',
                transform: 'translateX(-50%) rotate(180deg)',
                width: 0,
                height: 0,
                borderLeft: '1rem solid transparent',
                borderRight: '1rem solid transparent',
                borderTop: `1rem solid #cecece`,
              }}
            >
              <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
                <motion.img
                  src={item.imagem_produto}
                  alt={item.nome_produto}
                  width={200}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.2, duration: 0.3 }}
                />
              </motion.div>
            </Flex>
          )}
        </S.Td>
        <S.Td>{firstLetterUpperCaseAndRestLowerCase(item.cor)}</S.Td>
        <S.Td>
          <Text>{item.tipo_gravacao.slice(0, 10)}</Text>
          <Text>{item.tipo_gravacao.slice(10, 30)}</Text>
        </S.Td>
        <S.Td>{firstLetterUpperCaseAndRestLowerCase(item.prazo_entrega)}</S.Td>
        <S.Td position="relative">
          {item.nome_arte_finalista && (
            <Tooltip
              label={`
              Logo iniciada por: ${item.nome_arte_finalista} 
            `}
            >
              <Badge colorScheme="green" mr={2} position="absolute" top="5px" left="0" cursor={'pointer'}>
                {item.nome_arte_finalista.substring(0, 1)}
              </Badge>
            </Tooltip>
          )}
          <Text
            as={'a'}
            href={item.link_logo}
            target="_blank"
            color={'blue.500'}
            _hover={{
              filter: 'brightness(0.8)',
              textDecoration: 'underline',
            }}
            cursor={'pointer'}
            onClick={mutateAsync}
          >
            Logo
          </Text>
        </S.Td>
        <S.Td cursor={'pointer'}>
          <Tooltip label={item.observacoes}>
            {firstLetterUpperCaseAndRestLowerCase(item.observacoes.length > 15 ? item.observacoes.substring(0, 15) + '...' : item.observacoes)}
          </Tooltip>
        </S.Td>

        <S.Td textAlign={'center'}>
          <Text
            as={'a'}
            href={`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-base-layout/${item.numero_nota}/${item.sequencia}/${item.codigo_produto}/${item.id}/${codUsu}`}
            target="_blank"
            color={'blue.500'}
            _hover={{
              filter: 'brightness(0.8)',
              textDecoration: 'underline',
            }}
            cursor={'pointer'}
            onClick={mutateAsync}
          >
            Link
          </Text>
        </S.Td>
        <S.Td cursor={'pointer'} textAlign={'center'}>
          <Text
            as="a"
            href={item.link_layout}
            color={item.link_layout === '' ? 'red.500' : 'blue.500'}
            target="_blank"
            _hover={{
              filter: 'brightness(0.8)',
              textDecoration: 'underline',
            }}
            cursor={'pointer'}
          >
            Link
          </Text>
        </S.Td>
        <S.Td textAlign={'center'}>{item.quantidade_batidas}</S.Td>
        {isAdmin && (
          <S.Td textAlign={'center'}>
            <Button
              bgColor={'#378BBF'}
              color={'#fff'}
              size="sm"
              fontSize="sm"
              borderRadius="sm"
              _hover={{
                filter: 'brightness(0.8)',
              }}
              disabled={item.prioridade}
              onClick={updatePrioridade}
              isLoading={loading}
            >
              Prioridade
            </Button>
          </S.Td>
        )}
        <S.Td>{<Modal item={item} isBlocked={isBlocked} />}</S.Td>
        <S.Td>
          {/* <ModalCancel item={item} refreshInfo={refreshInfo} /> */}
          <Checkbox colorScheme="red" size="lg" onChange={() => handleSelectLayout(item)} />
        </S.Td>
        <S.Td>{item.data_finalizacao ? format(new Date(item.data_finalizacao), 'dd/MM/yyyy HH:mm') : 'Não finalizado'}</S.Td>
      </Tr>
    </>
  )
}

export const Row = memo(RowComponent, (prevProps, nextProps) => {
  return prevProps.item.id === nextProps.item.id && Object.is(prevProps.item, nextProps.item)
})
